import type { ScreenContext } from './types.ts';
import { renderTipCard } from '@/components/tip-card.ts';
import { selectGuidanceTips } from '@/calculations/guidance.ts';

export function renderGuidance(container: HTMLElement, ctx: ScreenContext) {
  const { state, dispatch } = ctx;
  const tips = selectGuidanceTips(state, state.guidanceTemplates);

  container.innerHTML = `
    <div class="card space-y-6">
      <div>
        <p class="text-sm uppercase tracking-wide text-gray-500">Guidance</p>
        <h2 class="text-2xl font-semibold text-gray-900">Use music intentionally</h2>
      </div>
      <div id="tips" class="space-y-3"></div>
      <div class="grid grid-cols-1 gap-3" id="actions"></div>
    </div>
  `;

  const tipContainer = container.querySelector('#tips') as HTMLElement;
  tips.forEach((tip) => tipContainer.appendChild(renderTipCard(tip)));

  const actions = container.querySelector('#actions') as HTMLElement;

  const saveBtn = document.createElement('button');
  saveBtn.className = 'btn-secondary w-full';
  saveBtn.textContent = 'Save session JSON';
  saveBtn.addEventListener('click', () => downloadSession(state));

  const newBtn = document.createElement('button');
  newBtn.className = 'btn-primary w-full';
  newBtn.textContent = 'Start new session';
  newBtn.addEventListener('click', () => dispatch({ type: 'RESET' }));

  const exitBtn = document.createElement('button');
  exitBtn.className = 'btn-secondary w-full';
  exitBtn.textContent = 'Exit';
  exitBtn.addEventListener('click', () => {
    dispatch({ type: 'RESET' });
    window.location.hash = '#/session';
  });

  actions.appendChild(saveBtn);
  actions.appendChild(newBtn);
  actions.appendChild(exitBtn);
}

function downloadSession(state: any) {
  const blob = new Blob([JSON.stringify(state, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `session-${state.sessionId || 'local'}.json`;
  a.click();
  URL.revokeObjectURL(url);
}
